    <!-- Page Header -->
    <div class="page-header">
        <div class="d-flex">
            <app-smart-select [tableName]="'clientDetails'" (selectedObj)="onSelection($event)"></app-smart-select>
        </div>
    </div>
    <!-- End Page Header -->

    <!-- Row -->
    <div class="row row-sm">
        <div class="col-xl-3 col-lg-12 col-md-12">
            <div class="card custom-card">
                <div class="card-header">
                    <h3 class="main-content-label">Client Budget</h3>
                </div>
                <div class="card-body text-center item-user">
                    <div class="profile-summary">
                        <div class="profile-pic-cnt">
                            <img *ngIf="!getField('imageUrl')" src="../assets/img/users/1.jpg" class="profile-image" alt="user">
                            <img *ngIf="getField('imageUrl')" src="{{getPhotoUrl()}}" class="profile-image" alt="user">
                        </div>
                        <a href="javascript: void(0)" class="text-dark"><h5 class="mt-3 mb-0 font-weight-semibold">{{getField('name')}} {{getField('lastname')}} {{getField('lastname2')}}</h5></a>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-xl-9 col-lg-12 col-md-12">
            <div >
                <div class="card-body">
                    <h4 *ngIf="!isUserSelected()">Select client</h4>
                    <div *ngIf="isUserSelected()">

                        <!-- PROFILE -->

                        <!-- PLANES ASOCIADOS -->
                        <div>
                            <div class="card-header border-bottom-0 pb-1">
                                <label class="main-content-label mb-2 pt-1">Planes asociados a este cliente</label>
                                <p class="tx-12 mb-0 text-muted">Sales activities are the tactics that salespeople use to achieve their goals and objective</p>
                            </div> 
                            <button mat-icon-button  color="primary" (click)="reload()">
                                <mat-icon>sync</mat-icon>
                            </button>
                            <mat-accordion>
                                <mat-expansion-panel hideToggle *ngFor="let plan of getPlans()">
                                    <mat-expansion-panel-header>
                                    <mat-panel-title>
                                        {{plan.name}}
                                    </mat-panel-title>
                                    <mat-panel-description>
                                        {{plan.description}}
                                    </mat-panel-description>
                                    </mat-expansion-panel-header>
                                    
                                    <!-- CONTENT -->
                                    <div class="p-3 font-weight-normal mb-0"><span class="price">{{plan.price}} {{plan.currency}}</span></div>
                                    <ul class="list-unstyled mb-0">
                                        <li><i class="fe fe-check me-2 text-success"></i>{{plan.category}}</li>
                                        <li><i class="fe fe-check me-2 text-success"></i>{{plan.package_type}}</li>
                                        <li><i class="fe fe-check me-2 text-success"></i>{{plan.category}}</li>
                                    </ul>

                                </mat-expansion-panel>
                            </mat-accordion>
                            
                        </div>
                    
                        <!-- CONFIRMATION -->
                        <div>
                            <mat-spinner *ngIf="isLoading()"></mat-spinner>
                            <div *ngIf="!isLoading()">
                                <div class="d-flex mb-4">
                                    <label class="main-content-label my-auto">Enviar cotización al cliente</label>
                                </div>
                                
                                <!-- COTIZACIONES CLIENTE -->
                                <mat-accordion>
                                    <mat-expansion-panel hideToggle *ngFor="let cotizacion of getClientCotizaciones()">
                                        <mat-expansion-panel-header>
                                        <mat-panel-title>
                                            Plan Id: {{cotizacion.FK_ID_plan}} -
                                            {{cotizacion.name}}
                                        </mat-panel-title>
                                        <mat-panel-description>
                                            {{cotizacion.description}}
                                        </mat-panel-description>
                                        </mat-expansion-panel-header>
                                        
                                        <!-- CONTENT -->
                                        <p>{{ cotizacion.data | json}}</p>
                                        <mat-slide-toggle [checked]="cotizacion.paid" >Paid</mat-slide-toggle><!-- (change)="onSlideToggleEvent($event)" -->

                                    </mat-expansion-panel>
                                </mat-accordion>

                                <div> <label id="code">Plan ID</label>
                                    <app-smart-select [tableName]="'plan'" (dataOut)="onPlanSelection($event)"></app-smart-select>
                                    <!-- <input type="text" class="form-control" placeholder="code"  [(ngModel)]="getCotizacionData().FK_ID_plan"> -->
                                </div>

                                <div class="row py-2">
                                    <div class="col-md-6">
                                        <label id="firstname">Due Date</label> 
                                        <app-date-picker [value]="getCotizacionData().dueDate" [fieldName]="'dueDate'" (selected)="setDate($event)"></app-date-picker>
                                        <!-- <input type="text" class="form-control" [(ngModel)]="getCotizacionData().dueDate" placeholder="valido hasta"> -->
                                    </div>
                                    <div class="col-md-6">
                                        <label id="phoneno" >Discount</label>
                                        <input type="tel" class="form-control" placeholder="% discount"  [(ngModel)]="getCotizacionData().discount">
                                    </div>
                                </div>

                                <div class="row py-2">
                                    <!-- <div class="col-md-6"> <label id="token">Token (auto-generated)</label>
                                        <input type="text" disabled class="form-control" placeholder="token"  [(ngModel)]="getCotizacionData().token">
                                    </div> -->
                                    <div class="col-md-3"> <label id="code">Code (auto-generated)</label>
                                        <input type="text" disabled class="form-control" placeholder="code"  [(ngModel)]="getCotizacionData().code">
                                    </div>
                                </div>
                                <div>
                                    <button type="button" class="btn btn-primary mb-1 me-1" (click)="createCotizacion()"><i class="ti-shopping-cart me-2"></i>Crear cotización</button>
                                    <button type="button" class="btn btn-primary mb-1 me-1" (click)="sendBudgetToClient()"><i class="ti-shopping-cart me-2"></i>TEST</button>
                                    <!-- <button type="button" class="btn btn-primary mb-1 me-1"><i class="ti-shopping-cart me-2"  (click)="sendCotizacion()"></i>Enviar cotización</button> -->
                                    <!-- <button type="button" class="btn btn-danger mb-1"><i class="ti-trash me-2"></i>Remove</button> -->
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>

        <div class="col-xl-9 col-lg-12 col-md-12">
            <div class="card custom-card">
                <div class="card-body">
                    <p>{{ cotizacion | json}}</p>
                </div>
            </div>
        </div>

    </div>